<py-modal
  [actions]="templateActions"
  [title]="'shoppingLists.export_title' | cxTranslate"
  [centered]="true"
  [scrollable]="true"
  [cxFocus]="focusConfig"
  (esc)="closeModal('escape pressed')"
>
  <div class="d-flex align-items-center">
    <label class="mr-2 d-flex align-items-center" role="button">
      <py-reactive-form-checkbox-slider
        [addMargin]="false"
        [group]="formGroup"
        [fieldName]="'displayPrices'"
      ></py-reactive-form-checkbox-slider>

      <span class="ml-2 mr-2">{{ 'shoppingLists.includePrices_heading' | cxTranslate }}</span>
    </label>
  </div>
</py-modal>

<ng-template #templateActions>
  <py-action-button
    [buttonClass]="'btn btn-plain-secondary'"
    [type]="'button'"
    [loading]="exportingAsXlsx"
    [buttonLabel]="'shoppingLists.exportToExcel_action' | cxTranslate"
    (click)="onExportXlsx()"
  >
    <i nz-icon nzType="file-excel"></i>
  </py-action-button>

  <py-action-button
    [buttonClass]="'btn btn-plain-secondary'"
    [type]="'button'"
    [loading]="exportingAsPdf"
    [buttonLabel]="'shoppingLists.exportToPdf_action' | cxTranslate"
    (click)="onExportPdf()"
  >
    <i nz-icon nzType="file-pdf"></i>
  </py-action-button>
</ng-template>
